import Inventory from "./Inventory";
import Utilities from "./Utilities";
import Settings from "./Settings";
import Stock from "./Stock";
import SalesPurchase from "./SalesPurchase";
import RestaurantSetup from "./RestaurantSetup";
import Customer from "./Customer";
import Accounts from "./Accounts";
import Booking from "./Booking";
import Vouchers from "./Vouchers";
export default {
  Inventory,
  Utilities,
  Settings,
  Stock,
  SalesPurchase,
  RestaurantSetup,
  Customer,
  Accounts,
  Booking,
  Vouchers,
};
